export const validateBranchName = (name) => {
    const regex = /^[a-zA-Z0-9 .]+$/;
    return regex.test(name);
  };